module.exports = __webpack_public_path__ + "img/steps_bottom_backgounrd.83161067.png";